import React from 'react';
import HarbourIcon from './HarbourIcon';
import './harbour.css';

/*
 * Harbour/Button. Kinds map to the component library: primary (plum, the one
 * filled action per view on SENCo surfaces), secondary (outline), tertiary
 * (text only), family (gold, service-user main action — never on SENCo
 * screens), warning (destructive, consequence spelled out by the caller).
 */
export default function HarbourButton({
  kind = 'primary',
  size = 'large',
  leadingIcon,
  trailingIcon,
  busy = false,
  busyLabel,
  children,
  className = '',
  type = 'button',
  ...rest
}) {
  const classes = [
    'harbour-btn',
    `harbour-btn--${kind}`,
    size === 'small' ? 'harbour-btn--small' : '',
    leadingIcon ? 'harbour-btn--icon-leading' : '',
    trailingIcon ? 'harbour-btn--icon-trailing' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} {...rest}>
      {busy ? (
        <>
          <HarbourIcon name="spinner" size={20} />
          {busyLabel || children}
        </>
      ) : (
        <>
          {leadingIcon && <HarbourIcon name={leadingIcon} size={20} />}
          {children}
          {trailingIcon && <HarbourIcon name={trailingIcon} size={20} />}
        </>
      )}
    </button>
  );
}
